import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidebar-close",
  "use": "icon-sidebar-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sidebar-close\"><path d=\"M2 2h1.667v20H2V2Zm11.845 13.822-2.988-2.989h11.81v-1.666h-11.81l2.988-2.989L12.667 7l-5 5 5 5 1.178-1.178Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol